// PriceChart Barrel Export
export { ChartControls } from './ChartControls';
export { default as ChartGridLine } from './ChartGridLine';
export { ChartHeader } from './ChartHeader';
export { default as ChartLine } from './ChartLine';
export { CustomTooltip } from './CustomTooltip';
// PriceChart is deliberately NOT re-exported here. It imports recharts (~1 MB),
// and this barrel is reached by '@/components', so re-exporting it put recharts
// in the initial bundle of every route — including text-only pages like /terms.
// Import it directly: `import PriceChart from '.../PriceChart/PriceChart'`.
